const accordionTitle = document.querySelector('.accordion__title');

if (accordionTitle) {
  attachEvent('.accordion__title', 'click', (e) => {
    const parentElem = e.target.closest('.accordion');
    const content = parentElem.querySelector('.accordion__content');
    parentElem.classList.toggle('is-open');
    slideToggle(content, 300, 'block');
  });
}
